const compatModules = {};import * as Mod1 from "./discourse/components/modal/policy-builder";
compatModules["discourse/components/modal/policy-builder"] = Mod1;

export * as discourse$components$modal$policy__builder$$__module from "./discourse/components/modal/policy-builder";
export {
default as discourse$components$modal$policy__builder$$default
} from "./discourse/components/modal/policy-builder";
import * as Mod2 from "./discourse/components/policy-builder-form";
compatModules["discourse/components/policy-builder-form"] = Mod2;

export * as discourse$components$policy__builder__form$$__module from "./discourse/components/policy-builder-form";
export {
default as discourse$components$policy__builder__form$$default
} from "./discourse/components/policy-builder-form";
import * as Mod3 from "./discourse/components/policy-group-input";
compatModules["discourse/components/policy-group-input"] = Mod3;

export * as discourse$components$policy__group__input$$__module from "./discourse/components/policy-group-input";
export {
default as discourse$components$policy__group__input$$default
} from "./discourse/components/policy-group-input";
import * as Mod4 from "./discourse/components/policy-reminder-input";
compatModules["discourse/components/policy-reminder-input"] = Mod4;

export * as discourse$components$policy__reminder__input$$__module from "./discourse/components/policy-reminder-input";
export {
default as discourse$components$policy__reminder__input$$default
} from "./discourse/components/policy-reminder-input";
import * as Mod5 from "./discourse/components/post-policy";
compatModules["discourse/components/post-policy"] = Mod5;

export * as discourse$components$post__policy$$__module from "./discourse/components/post-policy";
export {
default as discourse$components$post__policy$$default
} from "./discourse/components/post-policy";
import * as Mod6 from "./discourse/connectors/user-preferences-emails-pref-email-settings/preferences-policy-emails.gjs";
compatModules["discourse/connectors/user-preferences-emails-pref-email-settings/preferences-policy-emails"] = Mod6;

export * as discourse$connectors$user__preferences__emails__pref__email__settings$preferences__policy__emails$$__module from "./discourse/connectors/user-preferences-emails-pref-email-settings/preferences-policy-emails.gjs";
export {
default as discourse$connectors$user__preferences__emails__pref__email__settings$preferences__policy__emails$$default
} from "./discourse/connectors/user-preferences-emails-pref-email-settings/preferences-policy-emails.gjs";
import * as Mod7 from "./discourse/initializers/add-policy-builder";
compatModules["discourse/initializers/add-policy-builder"] = Mod7;

export * as discourse$initializers$add__policy__builder$$__module from "./discourse/initializers/add-policy-builder";
export {
default as discourse$initializers$add__policy__builder$$default
} from "./discourse/initializers/add-policy-builder";
import * as Mod8 from "./discourse/initializers/extend-for-policy";
compatModules["discourse/initializers/extend-for-policy"] = Mod8;

export * as discourse$initializers$extend__for__policy$$__module from "./discourse/initializers/extend-for-policy";
export {
default as discourse$initializers$extend__for__policy$$default
} from "./discourse/initializers/extend-for-policy";
import * as Mod9 from "./discourse/initializers/policy-admin-plugin-configuration-nav";
compatModules["discourse/initializers/policy-admin-plugin-configuration-nav"] = Mod9;

export * as discourse$initializers$policy__admin__plugin__configuration__nav$$__module from "./discourse/initializers/policy-admin-plugin-configuration-nav";
export {
default as discourse$initializers$policy__admin__plugin__configuration__nav$$default
} from "./discourse/initializers/policy-admin-plugin-configuration-nav";
import * as Mod10 from "./discourse/initializers/rich-editor-extension";
compatModules["discourse/initializers/rich-editor-extension"] = Mod10;

export * as discourse$initializers$rich__editor__extension$$__module from "./discourse/initializers/rich-editor-extension";
export {
default as discourse$initializers$rich__editor__extension$$default
} from "./discourse/initializers/rich-editor-extension";
import * as Mod11 from "./lib/discourse-markdown/policy";
compatModules["lib/discourse-markdown/policy"] = Mod11;

export * as lib$discourse__markdown$policy$$__module from "./lib/discourse-markdown/policy";
export {
setup as lib$discourse__markdown$policy$$setup
} from "./lib/discourse-markdown/policy";
import * as Mod12 from "./pre-initializers/policy-user-options";
compatModules["pre-initializers/policy-user-options"] = Mod12;

export * as pre__initializers$policy__user__options$$__module from "./pre-initializers/policy-user-options";
export {
default as pre__initializers$policy__user__options$$default
} from "./pre-initializers/policy-user-options";
export default compatModules;
